import { createSelector } from 'reselect';

const selectHistoryState = (state) => state.history;

export const selectHistoryItems = createSelector([selectHistoryState], (history) => history.items);
